/**
 * Create Custom Checklist Task API
 * Feature: 020-thinka-and-create
 */

import axiosInstance from '../axiosInstance';

export interface ChecklistItemRequest {
  title: string;
  ownerUserId?: number;
  dueDate?: string; // YYYY-MM-DD format
}

export interface CreateCustomChecklistTaskRequest {
  name: string;
  description?: string;
  checklistItems: ChecklistItemRequest[];
}

export interface ChecklistItemResponse {
  id: string;
  title: string;
  owner?: {
    id: number;
    name: string;
    email: string;
  };
  dueDate?: string;
  position: number;
}

export interface CustomChecklistTaskResponse {
  id: string;
  name: string;
  description?: string;
  companyId: number;
  checklistItems: ChecklistItemResponse[];
  createdByUserId: number;
  createdByUserName: string;
  createdAt: string;
  updatedAt: string;
  usageCount?: number;
}

export const createCustomChecklistTask = async (
  request: CreateCustomChecklistTaskRequest
): Promise<CustomChecklistTaskResponse> => {
  const response = await axiosInstance.post<CustomChecklistTaskResponse>(
    '/api/custom-checklist-tasks',
    request
  );

  return response.data;
};
